export default {
  en: {
    title: 'Facebook Browser Detected',
    subtitle: 'Please visit, {{subdomain}}/basket on another browser if you wish to to pay for your classes using Apple or Google Pay. Facebook does not support this method of payment.',
  },
};
